<div class="homepage" [class.preview-mode]="isPreviewMode">
  <div class="container-block">
    <div class="banner">
      <ng-container *ngIf="isDesktop">
        <img src="../../../../../public/assets/images/home-banner.png" alt="" />
      </ng-container>
      <div class="texts" nz-col [nzLg]="24" [nzXs]="24" [nzMd]="24">
        <p class="title">{{ 'homePage.greeting' | translate }} {{ user }}</p>
        <p class="subtitle" *ngIf="isDesktop">
          {{ 'homePage.subtitle' | translate }} <br />
          {{ 'homePage.subtitle_two' | translate }}
        </p>
        <p class="subtitle" *ngIf="!isDesktop">{{ 'homePage.subtitle' | translate }} {{ 'homePage.subtitle_two' | translate }}</p>
      </div>
    </div>
    <div class="container" nz-row>
      @if (appointments && appointments[0] && (appointments[0].appointmentStartDate || appointments[0].consultDate || isPreviewMode)) {
        <div class="card-appointment" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="8">
          <app-card-next-appointment [appointments]="appointments" (getAppointments)="getAppointments()"></app-card-next-appointment>
        </div>
      }
      <div class="container-card-misuration" nz-col nzXs="24" nzSm="24" nzMd="24" [nzLg]="24" [nzXl]="appointments && appointments.length > 0 ? 16 : 24">
        <nz-card class="card-misuration">
          <div class="card-misuration-header">
            <img style="width: 24px" src="../../../../../public/assets/images/mail.svg" alt="" />
            <span>{{ 'homePage.addMeasurements' | translate }}</span>
          </div>
          <div class="card-misuration-content">
            <p [ngStyle]="{ 'margin-bottom': selectedMeasurement ? '14px' : '2rem' }">{{ 'homePage.updateMeasurements' | translate }}</p>
            <form *ngIf="medicalForm" [formGroup]="medicalForm" [ngClass]="{ 'disabled-form': isPreviewMode }">
              <div>
                <div class="data">
                  <p class="data-p">{{ 'homePage.date' | translate }}</p>
                </div>
                <div class="datepicker-container">
                  <div class="datepicker">
                    <ds-datepicker [control]="medicalForm.get('date')" placeholder="{{ 'homePage.selectDate' | translate }}"></ds-datepicker>
                  </div>
                  <div>
                    <ds-select
                      [texts]="measurementTexts"
                      [values]="measurementValues"
                      [control]="medicalForm.get('type')"
                      placeholder="{{ 'homePage.parameter' | translate }}"
                      label="{{ isDesktop ? ('homePage.insertParameter' | translate) : ('homePage.insertParameterMobile' | translate) }}"
                    >
                    </ds-select>
                  </div>
                </div>

                <div class="content-container" [ngStyle]="{ 'padding-top': selectedMeasurement ? '0px' : '40px' }">
                  <!-- Pressione Arteriosa -->
                  @if (selectedMeasurement === 'pressure') {
                    <div class="flex-content">
                      <div class="form-field">
                        <span>{{ 'misuration.modalMisuration.maximum_pressure' | translate }}</span>
                        <ds-input-text [control]="medicalForm.get('maxValue')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
                        <span class="label-text">
                          {{ 'between' | translate }} {{ medicalLimits?.pressureLimits?.systolic?.min }} - {{ medicalLimits?.pressureLimits?.systolic?.max }}</span
                        >
                      </div>
                      <div class="form-field">
                        <span>{{ 'misuration.modalMisuration.minimum_pressure' | translate }}</span>
                        <ds-input-text [control]="medicalForm.get('minValue')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
                        <span class="label-text"
                          >{{ 'between' | translate }} {{ medicalLimits?.pressureLimits?.diastolic?.min }} - {{ medicalLimits?.pressureLimits?.diastolic?.max }}</span
                        >
                      </div>
                      <div class="form-field">
                        <span>BPM</span>
                        <ds-input-text [control]="medicalForm.get('pressureBpm')" [placeholder]="'misuration.modalMisuration.insert' | translate"> </ds-input-text>
                        <span class="label-text">{{ 'between' | translate }} {{ medicalLimits?.bpmLimits?.min }} - {{ medicalLimits?.bpmLimits?.max }}</span>
                      </div>
                    </div>
                  }

                  <!-- Peso Corporeo -->
                  @if (selectedMeasurement === 'weight') {
                    <div class="form-field">
                      <span>{{ 'misuration.modalMisuration.weight' | translate }}</span>
                      <ds-input-text [control]="medicalForm.get('weight')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
                      <span class="label-text">{{ 'between' | translate }} {{ medicalLimits?.weightLimit?.min }} - {{ medicalLimits?.weightLimit?.max }}</span>
                    </div>
                  }

                  <!-- Temperatura -->
                  @if (selectedMeasurement === 'temperature') {
                    <div class="form-field">
                      <span>{{ 'misuration.modalMisuration.temperature' | translate }}</span>
                      <ds-input-text [control]="medicalForm.get('temperature')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
                      <span class="label-text"
                        >{{ 'between' | translate }} {{ medicalLimits?.temperatureLimits?.celsius?.min }} - {{ medicalLimits?.temperatureLimits?.celsius?.max }}</span
                      >
                    </div>
                  }

                  <!-- Frequenza Cardiaca -->
                  @if (selectedMeasurement === 'bpm') {
                    <div class="form-field">
                      <span>{{ 'misuration.modalMisuration.bpm' | translate }}</span>
                      <ds-input-text [control]="medicalForm.get('bpm')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
                      <span class="label-text">{{ 'between' | translate }} {{ medicalLimits?.bpmLimits?.min }} - {{ medicalLimits?.bpmLimits?.max }}</span>
                    </div>
                  }

                  <!-- Glicemia -->
                  @if (selectedMeasurement === 'glycemia') {
                    <div style="display: flex; align-items: baseline" class="flex-content">
                      <div class="form-field">
                        <ds-select
                          class="glycemia"
                          [texts]="glycemiaFoodTexts"
                          [values]="glycemiaFoodValues"
                          [control]="medicalForm.get('measureType')"
                          [placeholder]="'Seleziona lo stato alimentare'"
                          [label]="'Misurazione'"
                        >
                        </ds-select>
                      </div>
                      <div class="form-field">
                        <ds-select
                          class="glycemia"
                          [texts]="glycemiaMeasurementTexts"
                          [values]="glycemiaMeasurementValues"
                          [control]="medicalForm.get('measureUnit')"
                          [placeholder]="'Seleziona il tipo di misurazione'"
                          [label]="'Tipo misurazione'"
                        >
                        </ds-select>
                      </div>
                      <div class="form-field">
                        <span>{{ 'misuration.modalMisuration.glycemia' | translate }}</span>
                        <ds-input-text [control]="medicalForm.get('glycemia')" [placeholder]="'misuration.modalMisuration.insert' | translate"></ds-input-text>
                        <span class="label-text">{{ 'between' | translate }} {{ medicalLimits?.glycemiaLimits?.min }} - {{ medicalLimits?.glycemiaLimits?.max }}</span>
                      </div>
                    </div>
                  }

                  <!-- Parametri generici -->
                  @if (
                    selectedMeasurement &&
                    selectedMeasurement !== 'isSmoker' &&
                    selectedMeasurement !== 'pressure' &&
                    selectedMeasurement !== 'glycemia' &&
                    selectedMeasurement !== 'bpm' &&
                    selectedMeasurement !== 'weight' &&
                    selectedMeasurement !== 'temperature' &&
                    selectedMeasurement !== 'bloodGroup'
                  ) {
                    <div class="form-field">
                      <span>{{ 'misuration.modalMisuration.' + [selectedMeasurement] | translate }}</span>
                      <ds-input-text
                        [type]="'number'"
                        [control]="medicalForm.get(selectedMeasurement!)"
                        [placeholder]="'misuration.modalMisuration.insert' | translate"
                      ></ds-input-text>
                    </div>
                  }
                  <div class="register-container">
                    <a class="register-btn" (click)="medicalForm.valid && registerMeasurement()"
                      >{{ 'homePage.checkIn' | translate }}<img src="../../../../../public/assets/images/icon-arrow.svg" style="margin-left: 10px"
                    /></a>
                  </div>
                </div>
                <div class="register-container-mobile">
                  <a class="register-btn" (click)="medicalForm.valid && registerMeasurement()"
                    >{{ 'homePage.checkIn' | translate }}<img src="../../../../../public/assets/images/icon-arrow.svg" style="margin-left: 10px"
                  /></a>
                </div>
              </div>
            </form>
          </div>
        </nz-card>
      </div>
      @if (healthBookingsText) {
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="16" class="card-list-container">
          <app-card-list [healthBookings]="healthBookingsText"></app-card-list>
        </div>
      }
      @if (functions.includes('MFD') || functions.includes('MFA') || isPreviewMode) {
      <div class="container-card-pill" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="7">
        <div class="header">
          <img src="../../../../../public/assets/images/pill.svg" alt="" />
          <p class="title-card">{{ 'homePage.requestMedicine' | translate }}</p>
        </div>
        <div class="container-MFA" *ngIf="functions.includes('MFA') || isPreviewMode">
          <p class="title-MFA">{{ 'homePage.titleMFA' | translate }}</p>
          <p class="subtitle-MFA">{{ 'homePage.subtitleMFA' | translate }}</p>
          <div class="container-MFA-text">
            <p>{{ 'homePage.textOneMFA' | translate }} {{ limit }} {{ 'homePage.textOneSecondMFA' | translate }}</p>
            <p>{{ 'homePage.textTwoMFA' | translate}}<b> 2,49€</b></p>
          </div>
        </div>

        <div class="container-MFD" *ngIf="functions.includes('MFD')">
          <p class="title-MFD">{{ 'homePage.titleMFD' | translate }}<b> 2,49€</b></p>
        </div>
        
        <div class="pill-btn">
          <ds-button
            class="button-mfa"
            (click)="openPharmap('GRATUITA')"
            *ngIf="functions.includes('MFA') || isPreviewMode"
            text="{{ 'homePage.inPolicy' | translate }}"
            [width]="'small'"
            [styleType]="'empty-main'"
          ></ds-button>
          <ds-button
            class="button-mfa"
            (click)="openPharmap('SCONTATA')"
            *ngIf="functions.includes('MFA') || isPreviewMode"
            text="{{ 'homePage.forPayment' | translate }}"
            [width]="'small'"
          ></ds-button>
          <ds-button class="button-mfd" (click)="openPharmap('PROSEGUI')" *ngIf="functions.includes('MFD')" text="{{ 'homePage.forMFD' | translate }}" [width]="'small'"></ds-button>
        </div>
      </div>
    }
      <div *ngIf="functions.includes('PPP') || functions.includes('PNP')" class="container-card-care" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
        <app-carousel-card [carouselElements]="carouselElements" (carouselEmitter)="onCarouselCarePathwayEmit($event)"></app-carousel-card>
      </div>
      @if (functions.includes('MNM') || isPreviewMode) {
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="16" class="container-card-convenzione">
          <app-search-structure [textPointer]="'MNM'"></app-search-structure>
        </div>
      }
      @if (functions.includes('MNF')) {
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="7" class="container-card-convenzione">
          <app-search-structure [textPointer]="'MNF'"></app-search-structure>
        </div>
      }
      @if (functions.includes('MAD') || isPreviewMode) {
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="7" class="info-container">
          <div class="title-info-card">
            <img src="../../../../../public/assets/images/user-notification.svg" alt="" />
            <p>{{ 'homePage.requestAssistance' | translate }}</p>
          </div>
          <div class="space-inside-info">
            <p class="first-p">{{ 'homePage.assistanceEveryWhere' | translate }}</p>
            <div class="richiedi-container">
              <a href="{{ homeAssistanceUrl }}" class="request-btn"
                >{{ 'homePage.request' | translate }}<img src="../../../../../public/assets/images/icon-arrow.svg" style="margin-left: 10px"
              /></a>
            </div>
          </div>
        </div>
      }
      @if (functions.includes('MNH')) {
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="{{ functions.includes('MNF') ? '7' : '16' }}" class="info-container">
          <app-visit-or-refunds></app-visit-or-refunds>
        </div>
      }
    </div>
  </div>
</div>
